// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3WuHs","content":"ManualTimeModal_content__3DXrV"};